import { io } from "socket.io-client";
const socket = io ();    
// //server to server

// const socket = io  ("https://hooshsabz.ir",{transports:['websocket']});   
 // local to server

// const socket = io ("http://localhost:4002", {transports:['websocket']} /*{ autoConnect: false }*/);    
 //local to local

export default socket;
